import { render, staticRenderFns } from "./BoxStoreList.vue?vue&type=template&id=295b84f7&"
import script from "./BoxStoreList.vue?vue&type=script&lang=js&"
export * from "./BoxStoreList.vue?vue&type=script&lang=js&"
import style0 from "./BoxStoreList.vue?vue&type=style&index=0&id=295b84f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QInnerLoading,QSpinnerTail})
